import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Liquidation penalty',
  description:
    'When a liquidation occurs, liquidators repay part or all of the outstanding borrowed amount on behalf of the borrower. In return, they can buy the collateral at a discount and keep the difference as a bonus!',
});
